module.exports = __webpack_public_path__ + "img/vertical.c57f1a0a.svg";